import Profile from "../components/Profile/Profile";
import Contact from "../components/Contact/Contact";

function HomePage() {
    return (
        <>
            <Profile />
            <Contact />
        </>
    );
}

export default HomePage;